<template>
  <section class="main-content is-transparent">
    <div class="hero">
      <div class="hero-body">
        <h1
          class="title is-2 is-uppercase has-text-primary has-text-weight-bold"
        >
          {{ $t("contribute.title") }}
        </h1>
        <h2 class="subtitle is-5 is-subtle has-text-weight-normal">
          {{ $t("contribute.description") }}
        </h2>
        <ContactForm />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
<script>
import ContactForm from "~/components/ContactForm";
// import Static from "~/components/Static/Static";
// import Editor from "~/components/Static/Editor";

// import SideChat from "~/components/sideChat";

// const GET_CONTACT = `
//   query GetContact ($id: ContactWhereUniqueInput!){
//     Contact(where: $id) {
//        firstName
//        lastName
//       id
//     }
//   }
// `;

export default {
  name: "Contribute",
  components: {
    // SideChat,
    ContactForm,
  },
  data() {
    return {
      pageTitle: "TDF*P — " + this.$t("contribute.meta.title"),
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  watch: {
    $route(to, from) {
      this.$store.commit("setCurrPageTitle", this.$t("contribute.header"));
    },
  },
  mounted() {
    this.$store.commit("setCurrPageTitle", this.$t("contribute.header"));

    this.enterAnimation();
  },
  head() {
    return {
      title: this.pageTitle,
    };
  },
  layout: "default",

  methods: {
    enterAnimation() {
      const anime = this.$anime;
      anime({
        targets: ".main-content",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        filter: ["blur(2rem)", "blur(0px)"],
        duration: 360,
      });
    },
  },
};
</script>
